@if (viewType == 'card') {

<div
  class="relative border border-dc-navy px-6 py-6 text-dc-navy dc-card-stretch"
>
  <!-- Membership Details -->
  <div class="space-y-4 dc-card-stretch-body">
    <!-- <h3 class="text-2xl font-semibold text-dc-navy min-h-10">Title</h3> -->
    <div class="mb-4 space-y-4">
      @for (f of data.fields; track f) { @if( f.value){
      <div class="dc-card-field">
        @if(f.label){
        <span class="dc-card-field-label"> {{ f.label | translate }}</span>
        }
        <span class="dc-card-field-value"> {{ f.value }}</span>
      </div>
      } }
    </div>
    @if(showActions){
    <div class="dc-card-stretch-actions">
      <div class="flex items-center gap-4 text-sm mt-7">
        <a class="card-action-edit-remove" (click)="onEdit(data)"
          >{{ "EDIT_DETAILS" | translate }}
        </a>
        <a
          class="card-action-edit-remove"
          (click)="onDelete(data)"
          >{{ "REMOVE" | translate }}
        </a>
      </div>
    </div>
    }
  </div>
  <!-- Bottom navy corner -->
  <div class="dc-card-corner-blue"></div>
</div>

} @if (viewType == 'list') {
<div class="space-y-4 mt-5">
  @for (c of data; track c) {
  <div class="flex flex-col">
    <!-- Section Title & Actions -->
    <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between">
      <h2 class="text-lg font-semibold">{{ c.title | translate }}</h2>
      <div class="flex gap-3 text-dc-navy mt-2 sm:mt-0 underline">
        <button type="button">{{ "BUTTONS.EDIT" | translate }}</button>
        <button type="button">{{ "BUTTONS.REMOVE" | translate }}</button>
      </div>
    </div>
    <!-- Fields -->
    <div class="flex flex-col divide-y divide-gray-200 mt-2 text-sm">
      @for (f of c.fields; track f) {
      <div class="flex flex-col sm:flex-row sm:gap-4 py-2">
        <div class="font-medium sm:w-1/3">{{ f.label | translate }}</div>
        <div class="sm:flex-1 text-dc-navy">{{ f.value }}</div>
      </div>
      }
    </div>
  </div>
  }
</div>
}
